<div class="flex items-center gap-3" *transloco="let t">
  <div
    class="w-20 py-2 bg-second-level rounded-lg flex items-center justify-end px-3"
    [attr.data-testid]="'usecase-duration-badge-' + useCase().generatedUseCaseId"
  >
    <span class="text-sm text-white font-bold">
      {{ formatDuration(useCase().duration) }}
    </span>
  </div>
  <div
    class="py-2 bg-second-level rounded-lg flex items-center justify-center px-3 gap-3"
    [pTooltip]="'project.steps.rfd.useCase.score.tooltip' | transloco"
    [escape]="false"
    tooltipStyleClass="tooltip-bg-second-level directus-tooltip"
    appendTo="body"
  >
    @if (useCase().score) {
      <div class="flex items-center gap-1">
        <i class="ph ph-star text-green-400"></i>
        <span class="text-sm text-white font-bold">{{ useCase().score!.strengthAttributes }}</span>
      </div>
      <div class="flex items-center gap-1">
        <i class="ph ph-sigma text-gray-300"></i>
        <span class="text-sm text-white font-bold">{{ useCase().score!.attributesScored }}</span>
      </div>
    } @else {
      <span class="text-sm text-white font-bold">-</span>
    }
  </div>

  <app-model-field-select-inclusion
    [id]="'usecase-select-' + useCase().generatedUseCaseId"
    [value]="included()"
    (valueChange)="onInclusionChange($event)"
    [isReadOnly]="disabled()"
    [pTooltip]="lockedTooltip()"
    appendTo="body"
    styleClass="w-40"
    [attr.data-testid]="'usecase-select-' + useCase().generatedUseCaseId"
  />
</div>
